(function () {
  'use strict';

  angular
    .module('temporaryWorkers')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('temporaryWorkers', {
        abstract: true,
        template: '<ui-view></ui-view>',
        url: '/temporary-workers',
        params: {
          message: null
        }
      });
  }
}());
